export default "__VITE_ASSET__DdRRYM43__"